export default {
  common: {
    done: 'Done',
  },
  paybylinkPage: {
    paybylink: 'Pay By Link',
    paybylink2: 'You are paying securely with paybylink',
    fillData: 'Review Personal Details',
    createCheckout: 'Enter Card Details',
    createCheckoutButton: 'Continue',
    confirmData: 'Pay with Paybylink',
    channel: 'Channel',
    payNow: 'Pay Now',
    email: 'Email Address',
    amount: 'Amount',
    currency: 'Currency',
    reference: 'Reference',
    postCode: 'Post Code',
    recurringType: 'Recurring Type',
    recurringTypes: {
      none: 'None',
    },
    creditCard: 'Credit Card',
    cardNo: 'Card Number',
    expiry: 'Expiry',
    cvv: 'CVV',
    cardHolder: 'Card Holder',
    cancel: 'Cancel',
    productDetails: 'Product details',
    paymentMethods: 'Payment Methods',
    payWithCard: 'Pay with card',
    editAmount: 'Edit amount',
    testTransaction: 'This is a test transaction',
    reference: 'Reference',
    remainingBalance: 'Remaining balance',
    compliance: {
      acceptPrefix: 'I have read and accept the ',
      termsLinkText: 'terms & conditions.',
      privacyLinkText: 'privacy policy.',
    },
    translations: 'Translations',
  },
  forms: {
    bank: 'Bank',
    emailInputLabel: 'Email Address',
    passwordInputLabel: 'Password',
    nameInputLabel: 'Name',
    confirmPasswordInputLabel: 'Confirm Password',
    fieldRequired: 'This field is required',
    fieldValueOutOfRange: 'Value out of range',
    required: 'Required',
    emailInvalid: 'Incorrect e-mail address',
    senderIdTwilioInvalid: 'Only letters, numbers, spaces allowed',
    amountInvalid: 'Invalid amount',
    expiryDateInvalid: 'Invalid expiry date',
    cvvInvalid: 'Invalid CVV',
    creditCardNoInvalid: 'Invalid credit card number',
    minAmountErr: 'The minimum payment amount is: {minAmount}',
    maxAmountErr: 'The maximum payment amount is: {max}',
    mustBePositive: 'Must be a positive amount',
  },
  dialogs: {
    paybylink: {
      successTitle: 'Transaction successful',
      pendingTitle: 'Transaction pending',
      pendingSubtitle: 'Transaction awaiting final confirmation from bank',
      successSubtitle: 'Your transaction has been sent successfully',
      failureTitle: 'Transaction failed',
      failureSubtitle: 'Your transaction has not been successful',
      unknownTitle: 'Payment status is unknown',
      redirectSubtitle: "You will be redirected to the merchant's website in a few seconds...",
      zohoRedirectSubtitle: 'You will be redirected to Zoho SecurePay in a few seconds...',
    },
    gotIt: 'Got it',
    tryAgain: 'Try Again',
    reference: 'Reference',
    amount: 'Amount',
  },
  datatables: {
    headers: {
      product: 'Product',
      quantity: 'Quantity',
      subtotal: 'Subtotal',
    },
  },
  apms: {
    payByBank: 'Pay By Bank',
    ideal: 'iDEAL | Wero',
    card: 'Card',
    applePay: 'Apple Pay',
    googlePay: 'Google Pay',
    satispay: 'Satispay',
    bancontact: 'Bancontact',
    fpx: 'Financial Process Exchange (FPX)',
    duitnowQr: 'DuitNow QR',
    mae: 'MAE | Maybank',
    shopeepay: 'ShopeePay',
    grabpay: 'GrabPay',
    boost: 'BOOST',
    touchNGo: 'Touch n Go',
    openBanking: 'Open Banking',
    chinaUnionPay: 'UnionPay',
  },
  pages: {
    indexTitle: 'Index paybylinks',
    aboutTitle: 'About paybylinks',
  },
  applePay: {
    errors: {
      generic: 'Something went wrong',
      withCode: 'Something went wrong... code: {code} info: {info}',
    },
    failureInfo: {
      paymentAuthorisationFailure: 'payment authorisation failure',
      sessionCreateFailure: 'session create failure',
    },
  },
  oppwa: {
    fields: {
      cardNumber: 'Card Number',
      expiry: 'Expiry',
      cvv: 'CVV',
      country: 'Country',
      billingCountry: 'Billing Country',
      pleaseSelect: 'Please select',
      stateProvince: 'State / Province',
      city: 'City',
      postcode: 'ZIP/Postal Code',
      addressLine1: 'Street Address Line 1',
      addressLine2Optional: 'Street Address Line 2 (Optional)',
      cardHolder: 'Card Holder',
      email: 'Email',
      givenName: 'Given name',
      surname: 'Surname',
      dateOfBirth: 'Date of birth',
      phoneNumber: 'Phone number',
    },
    errors: {
      invalidEmail: 'Invalid email address',
      invalidGivenName: 'Invalid given name',
      invalidSurname: 'Invalid surname',
      invalidDate: 'Invalid date',
      invalidPhoneNumber: 'Invalid phone number',
      billingStreet: 'Invalid street',
      billingCity: 'Invalid city',
      billingCountry: 'Invalid country',
    },
    sections: {
      personalDetails: 'Personal details',
      cardDetails: 'Card details',
      billingAddress: 'Billing address',
    },
  },
  errors: {
    unknownErrorMessage: 'An unknown error occurred',
    redirectErrorMessage: 'Error fetching redirect URL. Please contact support.',
    unhandledRedirectMessage: 'Unhandled redirect type. Please contact support.',
    pageNotFoundPayByLink:
      'Are you trying to pay using paybylink? Please make sure you have been redirected from your text message or email.',
  },
  resultDescriptions: {
    // to be expanded in the future
    '000-000-000': 'Transaction succeeded',
    '000-100-110': "Request successfully processed in 'Merchant in Integrator Test Mode'",
  },
}
